import { action, computed, makeObservable, observable } from 'mobx';
import { applicationStore } from '@pascal/pascal-core/shared/core/store';

class WinningAmountStore {
  winningAmount = null;

  demoWinningAmount = null;

  winType = null;

  lastWinAmount = 0;

  isPairWin = false;

  constructor() {
    makeObservable(this, {
      winningAmount: observable,
      lastWinAmount: observable,
      demoWinningAmount: observable,
      isPairWin: observable,
      winType: observable,
      setWinningAmount: action.bound,
      setWinType: action.bound,
      clearWinInfo: action.bound,
      setLastWin: action.bound,
      setIsPairWin: action.bound,
      winningAmountByMode: computed,
    });
  }

  get winningAmountByMode() {
    if (applicationStore.isDemo) {
      return this.demoWinningAmount;
    }
    return this.winningAmount;
  }

  setIsPairWin(bool) {
    this.isPairWin = bool;
  }

  setWinningAmount(winningAmount) {
    if (applicationStore.isDemo) {
      this.demoWinningAmount = winningAmount;
    } else {
      this.winningAmount = winningAmount;
    }
  }

  setWinType(winType) {
    this.winType = winType;
  }

  setLastWin(win) {
    this.lastWinAmount = win;
  }

  clearWinInfo() {
    this.winNumber = null;
    this.winningAmount = null;
    this.demoWinningAmount = null;
  }
}

export const winningAmountStore = new WinningAmountStore();
